import Skeleton from 'src/components/atoms/Skeleton';
import SkeletonDataGrid from 'src/components/containers/skeleton/SkeletonDataGrid';
import { AgText } from 'src/components/ui';
import { PRODUCTS_GRID_ID } from 'src/modules/line-items/utils/productLineItemUtils';

const columns = { a: {}, b: {}, c: {}, d: {} };

export const ProductsGridSkeleton = () => {
  return (
    <>
      <Skeleton>
        <AgText size="h6" className="pl-1 pb-2">
          Products
        </AgText>
      </Skeleton>
      <SkeletonDataGrid
        rowCount={4}
        columns={columns}
        gridKey="products-grid.skeleton"
        initialState={{ density: 'compact' }}
        hideFooter
        enterNewText="Add new product"
        storageKey={PRODUCTS_GRID_ID}
      />
    </>
  );
};
